
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.503","height":"15.979"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.344 7.938l-1.649 5.074v.008a1.3 1.3 0 00-.629-.167 1.313 1.313 0 00-1.313 1.313h-5a1.309 1.309 0 00-1.848-1.2L2.26 7.904a1.31 1.31 0 00.866-1.23h0a1.3 1.3 0 00-.328-.859l4.449-3.232a1.305 1.305 0 002.119 0l4.38 3.182a1.306 1.306 0 00.6 2.173zM9.288 2.527l.078.057a1.3 1.3 0 00.254-.77h0a1.313 1.313 0 10-2.373.771l.078-.057m0 0l-.078.057a1.305 1.305 0 002.119 0l-.078-.057m5.138 5.159l-.082.252a1.3 1.3 0 00.345.052 1.313 1.313 0 001.313-1.313h0a1.311 1.311 0 00-2.256-.91l.073.053m0 0l-.073-.053a1.306 1.306 0 00.6 2.173l.082-.252M2.796 5.822h0a1.317 1.317 0 10-.538 2.091l-.072-.221m0 0l.072.221a1.31 1.31 0 00.866-1.23h0a1.3 1.3 0 00-.328-.859h0m7.955 8.347h0a1.313 1.313 0 102.626 0h0a1.305 1.305 0 00-.684-1.145m0 0a1.3 1.3 0 00-.629-.167 1.313 1.313 0 00-1.313 1.313h0M3.879 12.89l.028.085a1.312 1.312 0 101.848 1.2h0m.313 0h-.312a1.309 1.309 0 00-1.848-1.2l.014.043","fill":"none","stroke":"#fff","stroke-linejoin":"round"}})])
          )
        }
      }
    